<table mat-table [dataSource]="this.table.paging?.response?.data" class="mat-elevation-z0 mat-table">

  <!-- Check Column -->
  <ng-container *ngIf="checkColumn"  matColumnDef="checkColumn">
    <th mat-header-cell *matHeaderCellDef class="bg-primary">
      <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()" class="mat-checkbox-border-white">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)">
      </mat-checkbox>
    </td>
  </ng-container>

  <!-- Other columns -->
  <ng-container *ngFor="let displayedColumn of displayedColumns; let columnIndex = index">
    <ng-container *ngIf="displayedColumn != 'checkColumn'">
      <ng-container matColumnDef="{{displayedColumn}}">
        <th mat-header-cell *matHeaderCellDef class="bg-primary white-color"> {{displayedColumn}} </th>
        <td mat-cell *matCellDef="let element; let elementIndex = index">
          <ng-container [ngTemplateOutlet]="table.columns[checkColumn ? columnIndex - 1 : columnIndex]?.template"
           [ngTemplateOutletContext]="{ data: table.paging?.response?.data[elementIndex], field: table.columns[checkColumn ? columnIndex - 1 : columnIndex]?.field }"></ng-container>
        </td>
      </ng-container>
    </ng-container>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
